import React from 'react';

import {
  List,
} from '@mui/material';

import type { DefecationJson } from '@/types/domain/defecation/entities/defecationEntity';

import CustomListItem from '@/components/CustomListItem';
import { MeasureDateTime } from '@/domain/defecation/service/entity/valueObjects/measureDateTime';
import { toStringDateTimeDisplay } from '@/utils/date';

const DefecationInfo: React.FC<{
  /** データ */
  data: DefecationJson,
}> = ({ data }) => {
  const {
    defecationCategory,
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name={MeasureDateTime.label}
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
      <CustomListItem
        name="種類"
        content={defecationCategory}
      />
    </List>
  );
};

export default DefecationInfo;
